import React from 'react';
import { EVSkeleton, EVGrid, EVTypography } from 'lib/components';
import clsx from 'lib/clsx';
import { useTranslation } from 'lib/translation';
import SitemapStyles from './SitemapStyles';

function LoadingScreen() {
  const { t } = useTranslation();
  const classes = SitemapStyles();
  return (
    <>
      <EVSkeleton animation="wave" variant="rect" className={classes.mapContainer} style={{ height: '100%' }} />
      <EVGrid className={clsx(classes.flexColumn, classes.buildingsContainer)}>
        <EVTypography className={classes.buildingsHeading}>{t('order_submitted__buildings')}</EVTypography>
        <EVGrid className={classes.flexColumn} style={{ gap: 6 }}>
          <EVTypography className={classes.propertyTypeHeading}>{t('order_submitted__product_type')}</EVTypography>
          <EVSkeleton animation="wave" variant="rect" />
        </EVGrid>
        <EVGrid className={clsx(classes.flexColumn, classes.buildingDetailsList)}>
          <EVSkeleton animation="wave" variant="rect" style={{ height: 50 }} />
          <EVSkeleton animation="wave" variant="rect" style={{ height: 50 }} />
          <EVSkeleton animation="wave" variant="rect" style={{ height: 50 }} />
        </EVGrid>
      </EVGrid>
    </>
  );
}

export default LoadingScreen;
